// extracted by mini-css-extract-plugin
export default {"Container":"Spinner_Container__KQ+bO","Spinner":"Spinner_Spinner__jO0B+","spinner":"Spinner_spinner__7f16G"};